import "./App.scss";
import { useState, useEffect, useCallback } from "react";
import { Routes, Route } from "react-router-dom";

import Navbar from "./components/Navbar";
import About from "./components/About";
import Schedule from "./components/Schedule";
import Network from "./components/Network";
import Imprint from "./components/Imprint";
import Modal from "./components/Modal";

function App() {
  const [modal, setModal] = useState("");
  const escFunction = useCallback((event) => {
    if (event.keyCode === 27) {
      setModal("");
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);

  return (
    <>
      <div className="App">
        <header className="App-header">
          <div id="hero">
            <h1>Binary Blast</h1>
            <div id="hero-date">↦ Dec 1 - Dec 2, 2023 ↤</div>
            <div>Leipzig Livecoding & Algorave Event</div>
          </div>
          <Navbar />
        </header>
        <main>
          <Routes>
            <Route path="/" element={<About setModal={setModal} />} />
            <Route
              path="/schedule"
              element={<Schedule setModal={setModal} />}
            />
            <Route path="/network" element={<Network />} />
            <Route path="/imprint" element={<Imprint />} />
          </Routes>
        </main>
      </div>
      {modal !== "" ? <Modal modal={modal} setModal={setModal} /> : <></>}
    </>
  );
}

export default App;
